import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaHome, FaChevronRight } from 'react-icons/fa';

const Breadcrumb = ({ customItems = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getBreadcrumbItems = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
    
    if (customItems.length > 0) {
      return customItems;
    }

    const items = [
      {
        label: 'Home',
        path: '/',
        icon: <FaHome className="text-xs" />
      }
    ];

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      // Customize labels for specific routes
      let label = segment;
      if (segment === 'songs') {
        label = 'Songs';
      } else if (segment === 'articles') {
        label = 'Articles';
      } else if (segment === 'temples') {
        label = 'Temples';
      } else if (segment === 'astrology') {
        label = 'Astrology';
      } else if (segment === 'live') {
        label = 'Live';
      } else if (segment === 'panchang') {
        label = 'Panchang';
      } else if (segment === 'contact-us') {
        label = 'Contact Us';
      } else if (segment === 'auth') {
        label = 'Login';
      } else if (segment === 'profile') {
        label = 'Profile';
      } else {
        // Capitalize first letter and replace hyphens with spaces
        label = segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
      }

      items.push({
        label,
        path: currentPath,
        isLast: index === pathSegments.length - 1
      });
    });

    return items;
  };

  const breadcrumbItems = getBreadcrumbItems();

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6">
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <FaChevronRight className="text-xs text-gray-400" />}
          <button
            onClick={() => navigate(item.path)}
            className={`flex items-center space-x-1 transition-colors ${
              item.isLast 
                ? 'text-orange-600 font-medium cursor-default' 
                : 'hover:text-orange-600'
            }`}
            disabled={item.isLast}
          >
            {item.icon && <span className="mr-1">{item.icon}</span>}
            <span>{item.label}</span>
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
